<template>
  <div>
    <el-tabs v-model="tab" type="card" @tab-click="tabClick">
      <el-tab-pane label="编辑人员信息" name="editor">
        <el-tree :data="data1" node-key="id" :default-expanded-keys="expandedKeys">
          <span class="custom-tree-node" slot-scope="{ node }">
            <span><i :class="node.icon"></i>{{ node.label }}</span>
            <span>
              <el-button v-if="node.data.type == 1" type="text" size="mini" @click.stop="() => append(node)"> 增加人员 </el-button>
              <el-button v-if="node.data.type == 2" type="text" size="mini" @click.stop="() => remove(node)"> 移除人员 </el-button>
            </span>
          </span>
        </el-tree>
      </el-tab-pane>
      <el-tab-pane label="专家人员信息" name="expert">
        <el-tree :data="data2" node-key="id" :default-expanded-keys="expandedKeys">
          <span class="custom-tree-node" slot-scope="{ node }">
            <span>{{ node.label }}</span>
            <span>
              <el-button v-if="node.data.type == 1" type="text" size="mini" @click.stop="() => append(node)"> 增加人员 </el-button>
              <el-button v-if="node.data.type == 2" type="text" size="mini" @click.stop="() => remove(node)"> 移除人员 </el-button>
            </span>
          </span>
        </el-tree>
      </el-tab-pane>
    </el-tabs>
    <el-drawer title="选择人员" :visible.sync="drawer" :direction="'rtl'" :size="600">
      <div style="padding: 20px">
        <SearchUser :single="true" :closeFun="closeDrawer" :yesFun="selectUser"></SearchUser>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import subjectApi from "@/api/subject"
import SearchUser from "@/components/SearchUser.vue"
export default {
  name: "SubjectUser",
  components: { SearchUser },
  data() {
    return {
      tab: "editor",
      drawer: false,
      data1: [],
      data2: [],
      expandedKeys: [],
      curNode: null,
    }
  },

  mounted() {
    this.loadData(1)
  },

  methods: {
    loadData(type) {
      subjectApi.getUsers(type).then((res) => {
        if (type == 1) {
          this.data1 = this.convertData(type, res.data)
        } else if (type == 2) {
          this.data2 = this.convertData(type, res.data)
        }
      })
    },

    convertData(type, data) {
      let tree = []
      for (let i = 0; i < data.length; i++) {
        let row = data[i]
        let users = []

        row.users.forEach(function (user) {
          users.push({
            id: "user-" + user.userId + "-" + type,
            label: user.loginName + "(" + user.userName + ")",
            scrId: user.userId,
            type: 2,
            icon: "iconUser",
          })
        })

        tree.push({
          id: "sub-" + row.subjectId + "-" + type,
          label: row.name,
          scrId: row.subjectId,
          type: 1,
          icon: "iconSubject",
          children: users,
        })
        this.expandedKeys.push("sub-" + row.subjectId + "-" + type)
      }
      return tree
    },

    tabClick(t) {
      this.tab = t.name
      this.loadData(this.tab == "editor" ? 1 : 2)
    },

    append(node) {
      this.drawer = true
      this.curNode = node
    },

    remove(node) {
      this.$confirm("确定将" + node.label + "从" + node.parent.label + "删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        subjectApi.removeUser(node.parent.data.scrId, node.data.scrId, this.tab == "editor" ? 1 : 2).then((res) => {
          if (res.code == 0) {
            this.loadData(this.tab == "editor" ? 1 : 2)
          } else {
            this.$alert("删除失败", "系统提示", {
              confirmButtonText: "确定",
            })
          }
        })
      })
    },

    closeDrawer() {
      this.drawer = false
    },

    selectUser(rows) {
      /* this.editor = rows[0].loginName + "（" + rows[0].userName + "）";
      this.form.chiefEditor = rows[0].userId; */
      this.drawer = false
      subjectApi.addUser(this.curNode.data.scrId, rows[0].userId, this.tab == "editor" ? 1 : 2).then((res) => {
        if (res.code == 0) {
          this.loadData(this.tab == "editor" ? 1 : 2)
        } else {
          this.$alert("添加失败，可能重复性添加", "系统提示", {
            confirmButtonText: "确定",
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
